export default __webpack_public_path__ + "static/media/arrow-right-green.7df2a65c.svg";